/*!
VueLayers
Vue 2 components to work with OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.9.1
@license MIT
@copyright (c) 2017-2018, Vladimir Vershinin <ghettovoice@gmail.com>
*/
import Vue from 'vue';
import Circle from 'ol/style/circle';
import { imageStyle, mergeDescriptors, withFillStrokeStyle } from '../core';

var props = {
  radius: {
    type: Number,
    default: 5
  }
};

var methods = {
  /**
   * @return {ol.style.Circle}
   * @protected
   */
  createStyle: function createStyle() {
    return new Circle({
      radius: this.radius,
      snapToPixel: this.snapToPixel,
      fill: this._fill,
      stroke: this._stroke
    });
  },

  /**
   * @returns {Object}
   * @protected
   */
  getServices: function getServices() {
    var vm = this;

    return mergeDescriptors(imageStyle.methods.getServices.call(this), {
      get stylesContainer() {
        return vm;
      }
    });
  },

  /**
   * @param {ol.style.Fill|Vue|undefined} fill
   * @return {void}
   */
  setFill: function setFill(fill) {
    fill = fill instanceof Vue ? fill.$style : fill;

    if (fill !== this._fill) {
      this._fill = fill;
      this.refresh();
    }
  },

  /**
   * @param {ol.style.Stroke|Vue|undefined} stroke
   * @return {void}
   */
  setStroke: function setStroke(stroke) {
    stroke = stroke instanceof Vue ? stroke.$style : stroke;

    if (stroke !== this._stroke) {
      this._stroke = stroke;
      this.refresh();
    }
  }
};

var watch = {
  radius: function radius() {
    this.refresh();
  }
};

var Style = {
  name: 'vl-style-circle',
  mixins: [imageStyle, withFillStrokeStyle],
  props: props,
  methods: methods,
  watch: watch
};

var index = {
  Style: Style,
  install: function install(Vue$$1) {
    Vue$$1.component(Style.name, Style);
  }
};

export default index;

//# sourceMappingURL=index.es.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/vuelayers/lib/circle-style/index.es.js
// module id = null
// module chunks = 